/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CallerRef,
  CheckRequest,
  CheckResult,
  CheckResults,
  Decision,
  FreeProvider,
  GetWorkspaceConfigResponse,
  InitiatedFrom,
  InitiatedFromComponent,
  MapString,
  MxRecordDefinition,
  PaginatedResultPublicLogRow,
  PublicLogRow,
  SpamCheckRunId,
  TestEvaluateEmailForNonsenseRequest,
  TestEvaluateRequest,
  UpdateWorkspaceConfigRequest,
  UsageBulkRequestRes,
  UsageRequestRes,
  WrappedLeaseRes,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "spam-checker";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * No description
   *
   * @tags checks
   * @name FindCurrentWorkspaceChecks
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/spam-checks
   * @secure
   */
  findCurrentWorkspaceChecks = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      GetWorkspaceConfigResponse,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/spam-checks`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findCurrentWorkspaceChecks */
  findCurrentWorkspaceChecksPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/spam-checks`);

  /**
   * No description
   *
   * @tags checks
   * @name UpsertWorkspaceChecks
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/spam-checks
   * @secure
   */
  upsertWorkspaceChecks = (
    tenantId: string,
    workspaceId: string,
    data: UpdateWorkspaceConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/spam-checks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for upsertWorkspaceChecks */
  upsertWorkspaceChecksPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/spam-checks`);

  /**
   * No description
   *
   * @tags checks
   * @name FindWorkspaceChecksByTimestamp
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/spam-checks/by-timestamp
   * @secure
   */
  findWorkspaceChecksByTimestamp = (
    tenantId: string,
    workspaceId: string,
    query: {
      timestamp: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      GetWorkspaceConfigResponse,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/spam-checks/by-timestamp`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findWorkspaceChecksByTimestamp */
  findWorkspaceChecksByTimestampPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      timestamp: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/spam-checks/by-timestamp`, query);

  /**
   * No description
   *
   * @tags logs
   * @name FindSpamCheckLogs
   * @request GET:/v1/tenant/{tenantId}/spam-check/logs
   * @secure
   */
  findSpamCheckLogs = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId?: string;
      initiatedFromComponent?: InitiatedFromComponent;
      /** @minLength 1 */
      initiatedFromComponentId?: string;
      fromInclusive?: string;
      toInclusive?: string;
      decision?: Decision;
      /** @min 0 */
      scoreLowerBoundInclusive?: number;
      /** @min 0 */
      scoreUpperBoundInclusive?: number;
      /** @minLength 1 */
      emailSubstring?: string;
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultPublicLogRow,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/spam-check/logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSpamCheckLogs */
  findSpamCheckLogsPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId?: string;
      initiatedFromComponent?: InitiatedFromComponent;
      /** @minLength 1 */
      initiatedFromComponentId?: string;
      fromInclusive?: string;
      toInclusive?: string;
      decision?: Decision;
      /** @min 0 */
      scoreLowerBoundInclusive?: number;
      /** @min 0 */
      scoreUpperBoundInclusive?: number;
      /** @minLength 1 */
      emailSubstring?: string;
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/spam-check/logs`, query);

  /**
   * No description
   *
   * @tags logs
   * @name GetSpamCheckLogBySpamCheckRunId
   * @request GET:/v1/tenant/{tenantId}/spam-check/logs/by-spam-check-run-id
   * @secure
   */
  getSpamCheckLogBySpamCheckRunId = (
    tenantId: string,
    query: {
      /** @format uuid */
      spamCheckRunId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PublicLogRow,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/spam-check/logs/by-spam-check-run-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSpamCheckLogBySpamCheckRunId */
  getSpamCheckLogBySpamCheckRunIdPathGetter = (
    tenantId: string,
    query: {
      /** @format uuid */
      spamCheckRunId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/spam-check/logs/by-spam-check-run-id`, query);

  /**
   * No description
   *
   * @tags logs
   * @name GetSpamCheckLogByInitiatedFrom
   * @request GET:/v1/tenant/{tenantId}/spam-check/logs/by-initiated-from
   * @secure
   */
  getSpamCheckLogByInitiatedFrom = (
    tenantId: string,
    query: {
      initiatedFrom: InitiatedFrom;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PublicLogRow,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/spam-check/logs/by-initiated-from`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSpamCheckLogByInitiatedFrom */
  getSpamCheckLogByInitiatedFromPathGetter = (
    tenantId: string,
    query: {
      initiatedFrom: InitiatedFrom;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/spam-check/logs/by-initiated-from`, query);

  /**
   * No description
   *
   * @tags checks
   * @name DefaultFreeProviderList
   * @request GET:/v1/tenant/{tenantId}/spam-checks/default/free-providers
   * @secure
   */
  defaultFreeProviderList = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      FreeProvider[],
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/spam-checks/default/free-providers`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for defaultFreeProviderList */
  defaultFreeProviderListPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/spam-checks/default/free-providers`);

  /**
   * No description
   *
   * @tags checks
   * @name DefaultMxRecordList
   * @request GET:/v1/tenant/{tenantId}/spam-checks/default/mx-records
   * @secure
   */
  defaultMxRecordList = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      MxRecordDefinition[],
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/spam-checks/default/mx-records`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for defaultMxRecordList */
  defaultMxRecordListPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/spam-checks/default/mx-records`);

  /**
   * No description
   *
   * @tags checks
   * @name DefaultLocalPartList
   * @request GET:/v1/tenant/{tenantId}/spam-checks/default/local-parts
   * @secure
   */
  defaultLocalPartList = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      string[],
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/spam-checks/default/local-parts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for defaultLocalPartList */
  defaultLocalPartListPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/spam-checks/default/local-parts`);

  /**
   * No description
   *
   * @tags checks
   * @name DefaultWorkspaceConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/default-spam-checks
   * @secure
   */
  defaultWorkspaceConfig = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      GetWorkspaceConfigResponse,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/default-spam-checks`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for defaultWorkspaceConfig */
  defaultWorkspaceConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/default-spam-checks`);

  /**
   * No description
   *
   * @tags evaluation
   * @name EvaluateSpamChecksSync
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/spam-check/evaluate/sync
   * @secure
   */
  evaluateSpamChecksSync = (tenantId: string, workspaceId: string, data: CheckRequest, params: RequestParams = {}) =>
    this.request<
      CheckResults,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/spam-check/evaluate/sync`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for evaluateSpamChecksSync */
  evaluateSpamChecksSyncPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/spam-check/evaluate/sync`);

  /**
   * No description
   *
   * @tags evaluation
   * @name TestEvaluateSpamChecks
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/spam-check/test-evaluate
   * @secure
   */
  testEvaluateSpamChecks = (
    tenantId: string,
    workspaceId: string,
    data: TestEvaluateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      CheckResults,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/spam-check/test-evaluate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for testEvaluateSpamChecks */
  testEvaluateSpamChecksPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/spam-check/test-evaluate`);

  /**
   * No description
   *
   * @tags evaluation
   * @name TestEvaluateEmailForNonsense
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/spam-check/test-evaluate-nonsense
   * @secure
   */
  testEvaluateEmailForNonsense = (
    tenantId: string,
    workspaceId: string,
    data: TestEvaluateEmailForNonsenseRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      CheckResult,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/spam-check/test-evaluate-nonsense`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for testEvaluateEmailForNonsense */
  testEvaluateEmailForNonsensePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/spam-check/test-evaluate-nonsense`);

  /**
   * @description Route given form and return data needed to continue the flow
   *
   * @tags evaluation
   * @name EvaluateSpamChecksAsyncGuest
   * @request POST:/v1/guest-external/tenant/{tenantId}/spam-check/eval/async
   * @secure
   */
  evaluateSpamChecksAsyncGuest = (tenantId: string, data: CheckRequest, params: RequestParams = {}) =>
    this.request<
      SpamCheckRunId,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/spam-check/eval/async`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for evaluateSpamChecksAsyncGuest */
  evaluateSpamChecksAsyncGuestPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/spam-check/eval/async`);

  /**
   * @description added as a alternative to the usages endpoint with GET method as not every http library support it
   *
   * @tags Lease
   * @name ListResourcesWhichUseThisResourceMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease
   * @secure
   */
  listResourcesWhichUseThisResourceMethodPut = (tenantId: string, data: UsageRequestRes, params: RequestParams = {}) =>
    this.request<
      WrappedLeaseRes[],
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseThisResourceMethodPut */
  listResourcesWhichUseThisResourceMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease`);

  /**
   * @description bulk PUT usages endpoint (GET method with body is not widely supported)
   *
   * @tags Lease
   * @name ListResourcesWhichUseQueriedResourcesMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease-by-ids
   * @secure
   */
  listResourcesWhichUseQueriedResourcesMethodPut = (
    tenantId: string,
    data: UsageBulkRequestRes,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedLeaseRes[],
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease-by-ids`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseQueriedResourcesMethodPut */
  listResourcesWhichUseQueriedResourcesMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease-by-ids`);
}
